import type { SelectProps as MuiSelectProps } from '@mui/material/Select/Select';
import MuiSelect from '@mui/material/Select/Select';
import type { MenuItemProps } from '@mui/material/MenuItem/MenuItem';
import MuiMenuItem from '@mui/material/MenuItem/MenuItem';
import type { FC } from 'react';
import type { ListItemTextProps } from '@mui/material/ListItemText/ListItemText';
import ListItemText from '@mui/material/ListItemText/ListItemText';
import InputLabel from '@mui/material/InputLabel/InputLabel';
import { FormControl } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText/FormHelperText';

export type SelectItemProps = { key: string; listItemProps: ListItemTextProps } & MenuItemProps;

export interface SelectProps extends Omit<MuiSelectProps, 'error'> {
  name: string;
  items: SelectItemProps[];
  error?: string;
}

export const Select: FC<SelectProps> = ({ items, error, ...props }) => {
  const labelId = `${props.name || '#'}-select-label`;

  return (
    <FormControl fullWidth size={props.size}>
      <InputLabel id={labelId}>{props.label}</InputLabel>
      <MuiSelect labelId={labelId} error={!!error} {...props}>
        {items.map(({ key, ...item }) => (
          <MuiMenuItem key={key} {...item}>
            <ListItemText {...item.listItemProps} />
          </MuiMenuItem>
        ))}
      </MuiSelect>
      <FormHelperText variant={props.variant} error={!!error}>
        {error}
      </FormHelperText>
    </FormControl>
  );
};
